import React, { Component,useState, useEffect } from "react";
import Pagination from "react-js-pagination"; 

const PaginationComponent = (props) => {
    const { activePage,setActivePage, limit, totalRecords, data, getPaginatedData } = props;
    const handlePageChange = (event, value) => { 
         setActivePage(event)
         getPaginatedData(event); 
       }; 
  
     return (
         <div className="pagination-wrapper">
           <Pagination
             aria-label="Page navigation"
             itemClass="page-item"
             linkClass="page-link"
             prevPageText="Prev"
             nextPageText="Next" 
             activePage={activePage}
             itemsCountPerPage={limit}
             totalItemsCount={totalRecords}
             onChange={handlePageChange}
             pageRangeDisplayed={5}
             hideNavigation={1}
           />
         </div>
       );
}

export default PaginationComponent
